import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleKeywordKeyPress } from "../../../common/handleKeyWordPress";
import { verifyCodeUrl } from "../../../common/infrastructure/endpoints";
import { post } from "../../../common/infrastructure/requests";
import { addPhoneNumberAction } from "../../twoFactor.actions";
import { removePhoneNumberAction } from "../../twoFactor.actions";

interface IVerificationCode {
  phoneNumber: string;
  onClose(): any;
  shouldDeletePhoneNumber?: string;
}

const verifyCode = async (verificationCode: string) => {
  try {
    const resp = await post<any, { code: string }>(verifyCodeUrl, {
      code: verificationCode,
    });
    if (resp) return true;
    return false;
  } catch (e) {
    return false;
  }
};

export const VerificationCode: React.FC<IVerificationCode> = (props) => {
  const [verificationCode, setVerificationCode] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleAttemptVerify = async () => {
    if (verificationCode.length !== 4) {
      setErrorMessage(t("You have entered too few characters"));
      return;
    }
    if (props.shouldDeletePhoneNumber) {
      dispatch(removePhoneNumberAction(props.shouldDeletePhoneNumber));
    }

    const addSuccess = await verifyCode(verificationCode);
    if (!addSuccess) {
      setErrorMessage(t("You have entered an incorrect code"));
      return;
    }
    dispatch(addPhoneNumberAction(props.phoneNumber));
    props.onClose();
    setErrorMessage(""); //cleanup
    setVerificationCode(""); //cleanup
  };
  return (
    <Grid container direction="column" wrap="nowrap">
      <DialogContent>
        <DialogTitle>{t("Entered phone number")}</DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3"> {props.phoneNumber}</Typography>
          <Button
            variant="text"
            color="secondary"
            //@ts-ignore
            onClick={() => props.previousStep()}
          >
            {t("Change telephone nr")}
          </Button>
        </Box>
        <Typography>{t("Enter the code you received via SMS")}</Typography>
        <TextField
          fullWidth
          id="phonenumber"
          variant="outlined"
          placeholder="_ _ _ _"
          required
          inputProps={{ type: "text", pattern: "d*", maxLength: 4 }}
          onChange={(e) => setVerificationCode(e.target.value)}
          helperText={errorMessage.length > 1 && errorMessage}
          onKeyDown={(e) => handleKeywordKeyPress(e, handleAttemptVerify)}
        />
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          <DialogContentText color="primary" style={{ margin: 0 }}>
            {t("Did you not receive an SMS code?")}
          </DialogContentText>
          <Box>
            <Button
              variant="text"
              color="secondary"
              //@ts-ignore
              onClick={() => props.previousStep()}
            >
              {t("Request new code")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          disabled={verificationCode.length !== 4}
          onClick={() => handleAttemptVerify()}
        >
          {t("Activate shell protection")}
        </Button>
      </DialogActions>
    </Grid>
  );
};
